import React from 'react'
import Manager from '../../public/components/Manager'
import ProcessManagementDetail from './ProcessManagementDetail'
Ext.require('Ext.Toast')

const config = {
    buttons: [
        { icon: 'plus', text: '添加 ...', handler: ({ showDetail }) => showDetail(ProcessManagementDetail) },
      ],
    columns: [
        { _text: '流程名称', minWidth: 150, locked: false, flex: 2, search: true },
        { _text: '分类', name:'表单分类', minWidth: 150, flex: 2, filter: true },
        { _text: '性质', minWidth: 150, flex: 2, filter:['select'] },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <ProcessManagementDetail {...props} id={data.id} />)
    }
}

export default props => <Manager {...props} config={config} />